@let t = type();
@if (t === "coming soon") {
  <div class="ribbon-v">{{ t }}</div>
} @else {
  <img class="ribbon" [src]="'maturity-level/' + t + '.png'" i18n-alt alt="Ribbon" />
}
